import type { Address } from '@strata-monorepo/shared-ui/types/Address'

export function formatAddress(address: Address): string {
  const secondary = address.secondary ? ` ${address.secondary}` : ''
  const city = address.city
  const state = address.state.toUpperCase()
  const zip = address.zipcode
  return `${address.street_line}${secondary}, ${city}, ${state} ${zip}`
}
